var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcfStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 45L62.5009 57.4992M75.0001 45V30L90.0001 15V30H105L90.0001 45H75.0001Z",
    stroke: "#719A5D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6512 15H60C51.0999 15 42.3996 17.6392 34.9994 22.5839C27.5991 27.5285 21.8314 34.5566 18.4254 42.7792C15.0195 51.0019 14.1283 60.0499 15.8647 68.7791C17.601 77.5082 21.8869 85.5264 28.1802 91.8198C34.4736 98.1132 42.4918 102.399 51.221 104.135C59.9501 105.872 68.9981 104.981 77.2208 101.575C85.4434 98.1686 92.4715 92.4009 97.4161 85.0007C102.361 77.6004 105 68.9002 105 60V58.3512",
    stroke: "#0D5F4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4992 64.9992C83.5954 69.4243 81.5097 73.5219 78.4637 76.8566C75.4178 80.1914 71.5254 82.6387 67.2001 83.9387C62.8747 85.2386 58.278 85.3426 53.8984 84.2395C49.5187 83.1365 45.5196 80.8677 42.326 77.6741C39.1324 74.4804 36.8635 70.4813 35.7605 66.1017C34.6575 61.722 34.7614 57.1253 36.0614 52.8C37.3613 48.4746 39.8087 44.5822 43.1434 41.5363C46.4782 38.4904 50.5758 36.4047 55.0008 35.5008",
    stroke: "#0D5F4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcfStep1);
export default __webpack_public_path__ + "static/media/PCFStep1.6f539bcf991372c6f4e3b87882b0d49f.svg";
export { ForwardRef as ReactComponent };